<div *ngIf="month" class="month">
  <div class="month__title">
    <div class="month__name u-medium-grey">
      <span>{{ month.monthLabel }} {{ month.yearLabel }}</span>
    </div>
  </div>
  <app-header-label-days [isWeekView]="false" [shortDays]="true"></app-header-label-days>
  <app-mot-month
    class="annual-grid-day"
    [motMonth]="month"
    [isAnnualView]="true"
    [isMomoUser]="isMomoUser"></app-mot-month>
</div>
